import styled from 'styled-components'
import GatsbyBackgroundImage from 'gatsby-background-image'

const Container = styled.section`
  position: relative;
  margin-top: 48px;
  height: 530px;
  overflow: hidden;

  @media(min-width: ${props => props.theme.mediaQuery.smallpc}) {
    margin-top: 64px;
    height: 600px;
  }
`

const Image = styled( GatsbyBackgroundImage )`
  height: 530px;
  padding-top: 92px;

  @media(min-width: ${props => props.theme.mediaQuery.smallpc}) {
    height: 600px;
  }
` as any

const StyledImageDiv = styled.div<{ imageUrl: string }>`
  height: 530px;
  padding-top: 92px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(${( props ) => props.imageUrl});

  @media (min-width: ${( props ) => props.theme.mediaQuery.smallpc}) {
    height: 600px;
  }
` as any

const Link = styled.a`
` as any

export { Container, Image, StyledImageDiv, Link }
